import { round } from "lodash";

export const isAdjQtyValid = (value, isXDept = false) => {
  const reservedAdjQty = isXDept ? [0, 777, 888, 999] : [777, 888, 999];
  return !reservedAdjQty.includes(value);
};

export const isBrowserOnline = () => {
  return window.navigator.onLine;
};

export const MemberNoValidation = {
  pattern: {
    value: /^(?!.*-$)(?:\d{1,5}|(?:\d{1,5}-)?\d?)$/,
    message: "Please enter a valid member number",
  },
};

export function isNumeric(str) {
  if (typeof str !== "string") return false;
  return !isNaN(str) && !isNaN(parseFloat(str));
}

export function prettyNumericRound(number, places = 2) {
  return round(number, places).toFixed(places);
}

export function getFormattedNumber(number) {
  if (!number) {
    return number;
  }
  let parts = number.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

export function handleCommonError(errorHandler) {
  errorHandler("Something went wrong. Please try again.", "error");
}

export function getFileNameFromUrl(url = "") {
  if (typeof url === "string") {
    return url?.substring(url?.lastIndexOf("/") + 1)?.split(".")[0] ?? "";
  }
  return "";
}

export function getAdjQtyErrorScope(adjQtyError, data) {
  const scopes = Object.keys(data);
  let details = {
    scope: null,
    pogIndex: null,
    pogId: null,
  };
  for (let i = 0; i < scopes.length; i++) {
    const currentScope = scopes[i];
    const pogList = data[currentScope];
    for (let j = 0; j < pogList.length; j++) {
      const itemList = pogList[j]?.subRows || [];
      for (let k = 0; k < itemList.length; k++) {
        if (itemList[k].id === adjQtyError) {
          details.scope = currentScope;
          details.pogIndex = j;
          details.pogId = pogList[j]?.id;
          break;
        }
      }
      if (details.scope) {
        break;
      }
    }
    if (details.scope) {
      break;
    }
  }
  return details;
}

export function roundToNearestNumber(value, nearest, maxVal = 9999) {
  if (!value) {
    return nearest;
  }
  const mulVal = Math.round(value / nearest);
  let roundVal = mulVal * nearest;
  if (roundVal > maxVal) {
    roundVal = (mulVal - 1) * nearest;
  }
  return roundVal;
}

export const BULK_FOOTAGE = "Bulk";

export function getFootageValue(value = "", skipFtPrefix = false) {
  return String(value).trim().toLowerCase() === BULK_FOOTAGE.toLowerCase()
    ? BULK_FOOTAGE
    : skipFtPrefix
    ? value || 0
    : `${String(value || 0).trim()}ft`;
}

export const getMissingValue = (entity = {}) => {
  return (
    entity?.IsMissing || // If missing yes(true) then do calculation
    (!entity?.IsMissing && entity?.SelectedItem === singleValue.yes) // if missing no and user selected it(sel: Y) explicitly for order then do calculation
  );
};

export function isBulkFootage(value = "") {
  if (!value) {
    return false;
  }
  return String(value).trim().toLowerCase() === BULK_FOOTAGE.toLowerCase();
}

export function isResetSelectionForFilter(departmentFilters, adjQty = 0) {
  return ["SKU", "Vendor"].includes(departmentFilters.viewBy) && adjQty === 0;
}

export const OVERRIDE_TYPE = {
  itemLevel: "I",
  headerLevel: "H",
  filterLevel: "D",
};

export const ENTITY_TYPES = {
  department: "department",
  discount: "discount",
  planogram: "planogram",
  item: "item",
  orders: "orders",
  ssPlanogram: "store-supplies-planogram",
  ssItem: "store-supplies-item",
};

export const TierColorMappings = {
  1: "#0288d1bd", // T1-Blue
  2: "#8bc34ad1", // T2-Green
  3: "#ffc107ab", // T3-Yellow
  4: "#ff5722b8", // T4-Red
};

export const getIndicators = (
  discontinued,
  restricted,
  selected,
  released,
  existing,
  duplicate,
  fillIn
) => {
  if (fillIn) {
    return "4px 0 0 0 rgb(77,182,172) inset";
  } else if (released) {
    return "4px 0 0 0 green inset";
  } else if (discontinued) {
    return "4px 0 0 0 red inset";
  } else if (restricted) {
    return "4px 0 0 0 orange inset";
  } else if (selected) {
    return "4px 0 0 0 blue inset";
  } else if (existing) {
    return "4px 0 0 0 rgb(156,39,176) inset";
  } else if (duplicate) {
    return "4px 0 0 0 rgb(0,0,0) inset";
  } else {
    return "";
  }
};

export const ORDER_STATUS = {
  released: "RELEASED",
  notReleased: "NOT RELEASED",
};

export const NOTE_TYPE_VALUE = {
  planner: "PlannerNotes",
  retailer: "RetailerNotes",
};

export const SUB_TYPE = {
  sub: "Substitute",
  ref: "Referral",
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 235,
    },
  },
};

export const multiplierOptions = [1, 2, 3, 4];
export const multiplierMappings = {
  1: "1x",
  2: "2x",
  3: "3x",
  4: "4x",
};

export const DropdownSx = {
  whiteSpace: "unset",
  wordBreak: "break-word",
};

export const orderStatus = {
  released: "Released",
  notReleased: "Not Released",
};

export const FILL_IN_ORDER_TYPE_ID = 2;

export const UPLOAD_STATUS = ["Success", "Error", "InProgress"];

export const singleValue = {
  yes: "Y",
  no: "N",
  existing: "E",
};

export const booleanValue = {
  zero: 0,
  one: 1,
};

export const ssItemFilterByOptions = {
  0: { label: "Fixture Name", value: "ItemDescription" },
  1: { label: "SKU #", value: "SKU" },
  2: {
    label: "Type",
    value: {
      field: "Type",
      operator: "exactEquals",
      operand: ["1", "2", "3", "4", "5"],
    },
  },
  3: {
    label: "Selected = Y",
    value: {
      field: "SelectedItem",
      operator: "equals",
      operand: singleValue.yes,
    },
  },
  4: {
    label: "Selected = N",
    value: {
      field: "SelectedItem",
      operator: "equals",
      operand: [singleValue.no, null, ""],
    },
  },
  5: {
    label: "Adj. Qty = 0",
    value: { field: "AdjQty", operator: "equals", operand: booleanValue.zero },
  },
  6: {
    label: "Adj. Qty > 0",
    value: {
      field: "AdjQty",
      operator: "greaterThan",
      operand: booleanValue.zero,
    },
  },
  7: {
    label: "Restricted = Y",
    value: {
      field: "Restricted",
      operator: "equals",
      operand: singleValue.yes,
    },
  },
  8: {
    label: "Restricted = N",
    value: {
      field: "Restricted",
      operator: "equals",
      operand: singleValue.no,
    },
  },
  9: {
    label: "OSO Selected = Y",
    value: {
      field: "OSOSelected",
      operator: "equals",
      operand: 1,
    },
  },
  10: {
    label: "OSO Selected = N",
    value: {
      field: "OSOSelected",
      operator: "equals",
      operand: 0,
    },
  },
  11: {
    label: "Released",
    value: {
      field: "ReleaseStatus",
      operator: "equals",
      operand: orderStatus.released,
    },
  },
  12: {
    label: "Not Released",
    value: {
      field: "ReleaseStatus",
      operator: "equals",
      operand: [orderStatus.notReleased, null, ""],
    },
  },
  13: { label: "Release Date", value: "ReleaseDate" },
  14: { label: "Vendor Name", value: "VendorName" },
};

export const ssItemSortByOptions = {
  0: { label: "Fixture Name", value: "ItemDescription" },
  1: { label: "SKU #", value: "SKU" },
  2: { label: "Selected", value: "SelectedItem" },
  3: { label: "Adj. Qty", value: "AdjQty" },
  4: { label: "Adj. Cost", value: "AdjCost" },
  5: { label: "Type", value: "_type" },
  6: { label: "Release Date", value: "ReleaseDate" },
  7: { label: "Vendor", value: "VendorName" },
};

export const ssPogFilterByOptions = {
  0: { label: "POG #", value: "PlanogramNumber" },
  1: { label: "POG Name", value: "PlanogramName" },
  2: { label: "Department", value: "DepartmentName" },
  3: { label: "Category", value: "Category" },
  4: {
    label: "SKU #",
    value: "SKU",
  },
  5: {
    label: "Vendor",
    value: "Vendor",
  },
  6: {
    label: "Selected = Y",
    value: {
      field: "Selected",
      operator: "equals",
      operand: singleValue.yes,
    },
  },
  7: {
    label: "Selected = N",
    value: {
      field: "Selected",
      operator: "equals",
      operand: [singleValue.no, null, ""],
    },
  },
  8: {
    label: "OSO Selected = Y",
    value: {
      field: "OSOSelected",
      operator: "equals",
      operand: 1,
    },
  },
  9: {
    label: "OSO Selected = N",
    value: {
      field: "OSOSelected",
      operator: "equals",
      operand: 0,
    },
  },
  10: {
    label: "Adj. Qty = 0",
    value: {
      field: "AdjQty",
      operator: "equals",
      operand: [booleanValue.zero, null, ""],
    },
  },
  11: {
    label: "Adj. Qty > 0",
    value: {
      field: "AdjQty",
      operator: "greaterThan",
      operand: booleanValue.zero,
    },
  },
  12: {
    label: "Restricted = Y",
    value: {
      field: "RestrictedInd",
      operator: "equals",
      operand: true,
    },
  },
  13: {
    label: "Restricted = N",
    value: {
      field: "RestrictedInd",
      operator: "equals",
      operand: false,
    },
  },
  14: {
    label: "Released",
    value: {
      field: "ReleaseStatus",
      operator: "equals",
      operand: orderStatus.released,
    },
  },
  15: {
    label: "Not Released",
    value: {
      field: "ReleaseStatus",
      operator: "equals",
      operand: [orderStatus.notReleased, null, ""],
    },
  },
  16: { label: "Release Date", value: "ReleaseDate" },
};

export const ssPogSortByOptions = {
  0: { label: "POG Name", value: "PlanogramName" },
  1: { label: "POG #", value: "PlanogramNumber" },
  2: { label: "Category", value: "Category" },
  3: { label: "Release Date", value: "ReleaseDate" },
};

export const itemFilterByOptions = {
  0: { label: "Description", value: "ItemDescription" },
  1: { label: "SKU #", value: "StoreItemId" },
  2: { label: "Vendor Name", value: "VendorName" },
  3: {
    label: "Selected = Y",
    value: {
      field: "SelectedItem",
      operator: "equals",
      operand: singleValue.yes,
    },
  },
  4: {
    label: "Selected = N",
    value: {
      field: "SelectedItem",
      operator: "equals",
      operand: [singleValue.no, null, ""],
    },
  },
  5: {
    label: "Selected = E",
    value: {
      field: "SelectedItem",
      operator: "equals",
      operand: singleValue.existing,
    },
  },
  6: {
    label: "Hazmat = Y",
    value: { field: "Hazmat", operator: "equals", operand: singleValue.yes },
  },
  7: {
    label: "Hazmat = N",
    value: {
      field: "Hazmat",
      operator: "equals",
      operand: [singleValue.no, null, ""],
    },
  },
  8: {
    label: "Restricted = Y",
    value: {
      field: "Restricted",
      operator: "equals",
      operand: singleValue.yes,
    },
  },
  9: {
    label: "Restricted = N",
    value: {
      field: "Restricted",
      operator: "equals",
      operand: singleValue.no,
    },
  },
  10: {
    label: "Adj. Qty = 0",
    value: { field: "AdjQty", operator: "equals", operand: booleanValue.zero },
  },
  11: {
    label: "Adj. Qty > 0",
    value: {
      field: "AdjQty",
      operator: "greaterThan",
      operand: booleanValue.zero,
    },
  },
  12: {
    label: "Released",
    value: {
      field: "ReleaseStatus",
      operator: "equals",
      operand: orderStatus.released,
    },
  },
  13: {
    label: "Not Released",
    value: {
      field: "ReleaseStatus",
      operator: "equals",
      operand: [orderStatus.notReleased, null, ""],
    },
  },
  14: { label: "Release Date", value: "ReleaseDate" },
  15: {
    label: "Discontinued = Y",
    value: {
      field: "DiscInd",
      operator: "equals",
      operand: booleanValue.one,
    },
  },
  16: {
    label: "Discontinued = N",
    value: {
      field: "DiscInd",
      operator: "equals",
      operand: [booleanValue.zero, null, ""],
    },
  },
  17: {
    label: "Missing = Y",
    value: {
      field: "IsMissing",
      operator: "equals",
      operand: true,
    },
  },
  18: {
    label: "Missing = N",
    value: {
      field: "IsMissing",
      operator: "equals",
      operand: false,
    },
  },
  19: { label: "PO Number", value: "PONumber" },
};

export const itemSortByOptions = {
  0: { label: "Description", value: "ItemDescription" },
  1: { label: "SKU #", value: "StoreItemId" },
  2: { label: "Vendor", value: "VendorName" },
  3: { label: "Release Date", value: "ReleaseDate" },
  4: { label: "Selected", value: "SelectedItem" },
  5: { label: "Restricted", value: "Restricted" },
  6: { label: "Hazmat", value: "Hazmat" },
  7: { label: "Adj. Cost", value: "AdjCost" },
  8: { label: "Ext. Cost", value: "ExtendedCost" },
};

export const pogFilterByOptions = {
  0: { label: "POG #", value: "PlanogramNumber" },
  1: { label: "POG Name", value: "PlanogramName" },
  2: { label: "Category", value: "Category" },
  3: {
    label: "Selected = Y",
    value: {
      field: "Selected",
      operator: "equals",
      operand: singleValue.yes,
    },
  },
  4: {
    label: "Selected = N",
    value: {
      field: "Selected",
      operator: "equals",
      operand: [singleValue.no, null, ""],
    },
  },
  5: {
    label: "Selected = E",
    value: {
      field: "Selected",
      operator: "equals",
      operand: singleValue.existing,
    },
  },
  6: {
    label: "Adj. Qty = 0",
    value: {
      field: "AdjQty",
      operator: "equals",
      operand: [booleanValue.zero, null, ""],
    },
  },
  7: {
    label: "Adj. Qty > 0",
    value: {
      field: "AdjQty",
      operator: "greaterThan",
      operand: booleanValue.zero,
    },
  },
  8: {
    label: "Hazmat = Y",
    value: { field: "HazmatInd", operator: "equals", operand: true },
  },
  9: {
    label: "Hazmat = N",
    value: {
      field: "HazmatInd",
      operator: "equals",
      operand: false,
    },
  },
  10: {
    label: "Restricted = Y",
    value: {
      field: "RestrictedInd",
      operator: "equals",
      operand: true,
    },
  },
  11: {
    label: "Restricted = N",
    value: {
      field: "RestrictedInd",
      operator: "equals",
      operand: false,
    },
  },
  12: {
    label: "Released",
    value: {
      field: "ReleaseStatus",
      operator: "equals",
      operand: orderStatus.released,
    },
  },
  13: {
    label: "Not Released",
    value: {
      field: "ReleaseStatus",
      operator: "equals",
      operand: [orderStatus.notReleased, null, ""],
    },
  },
  14: { label: "Release Date", value: "ReleaseDate" },
};

export const pogSortByOptions = {
  0: { label: "POG Name", value: "PlanogramName" },
  1: { label: "POG #", value: "PlanogramNumber" },
  2: { label: "Category", value: "Category" },
  3: { label: "Release Date", value: "ReleaseDate" },
};

export const sortTypeOptions = ["Ascending", "Descending"];

export const getPogValue = (pogValue, fallbackValue) => {
  let pog = fallbackValue;
  if (!!pogValue) {
    const partials = pogValue?.split("-");
    if (partials?.length > 1) {
      pog = partials[1] || null;
    } else {
      pog = pogValue;
    }
  }
  return pog;
};

export const isValidMissingSku = (pog = {}) => {
  return pog?.MissingSkus === 0;
};

// It retains cached rows and prevent showing skeleton loading again
export const KeepCacheAsIs = (filteredData = [], data = []) => {
  try {
    let _data = [];
    const _cachedKeys = filteredData?.reduce((acc, entity, index) => {
      if (!entity.virtualLoading) {
        acc.push(index);
      }
      return acc;
    }, []);
    for (let i = 0, len = data.length; i < len; i++) {
      const _entity = data[i];
      if (_cachedKeys.includes(i)) {
        _data.push({ ..._entity, virtualLoading: false });
      } else {
        _data.push(_entity);
      }
    }
    return _data;
  } catch (_error) {
    return data;
  }
};

export const isDropShipItem = (item = {}) => {
  return item?.Type === 5 || String(item?.SKU) === "999999";
};
